<template>
  <div class="side-panel">
    <v-layout white>
      <search-bar @search="filteredCompanies = filterTable(companies, $event)" :columns="headers"></search-bar>
      <v-spacer></v-spacer>
      <v-btn v-if="$store.state.user !== null && $store.state.user.role_type === RoleTypes.SuperAdmin"
        slot="action"
        @click="createCompanyModalVisible = true"
        class="secondary"
        light
        medium>
        {{$t('companyDetails.addCompany')}}
      </v-btn>
    </v-layout>
      <v-data-table
        :headers="headers"
        :items="filteredCompanies"
        hide-actions
        :loading="loading && error === null"
      >
        <template slot="items" slot-scope="props">
          <tr @click="editCompanyModalVisible = true; clickedId = props.item.company_id">
            <td class="text-xs-center">{{ props.item.company_id }}</td>
            <td class="text-xs-center">{{ props.item.company_name }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="danger-alert" v-if="error"> {{error}} </div>
    <v-dialog v-model="createCompanyModalVisible" max-width="500px">
      <create-company v-on:close="createCompanyModalVisible = false; loadData()"></create-company>
    </v-dialog>
    <v-dialog v-model="editCompanyModalVisible" max-width="500px">
      <edit-company v-on:close="editCompanyModalVisible = false; loadData()" :clickedId="this.clickedId"></edit-company>
    </v-dialog> 
  </div>
</template>

<script>
import CompaniesService from '@/services/CompaniesService'
import EditCompany from '@/components/EditCompany'
import CreateCompany from '@/components/CreateCompany'

import FilterTable from '@/helpers/FilterTable.js'
import { RoleTypes } from '@/constants/role_types'

export default {
  components: {
    EditCompany,
    CreateCompany
  },
  mixins: [FilterTable],
  data () {
    return {
      headers: [
        { text: this.$t('companyGenerics.companyId'),
          align: 'center',
          value: 'company_id'
        },
        { text: this.$t('companyGenerics.companyName'),
          value: 'company_name',
          align: 'center' },
        { text: this.$t('companyGenerics.companyDescr'),
          value: 'description',
          align: 'center' }
      ],
      error: null,
      companies: [],
      loading: null,
      createCompanyModalVisible: false,
      editCompanyModalVisible: false,
      clickedId: null, // identify the Company to be edited
      filteredCompanies: [],
      RoleTypes: RoleTypes
    }
  },
  async mounted () {
    await this.loadData()
  },
  methods: {
    async loadData () {
      try {
        this.error = null
        this.loading = true
        this.filteredCompanies = this.companies = (await CompaniesService.list()).data
        this.loading = false
      } catch (err) {
        this.error = err.response.data.error.message
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Companies.vue